import {
  MACHINES_ERROR, MACHINES_LOADING,
  MACHINES_UPDATE, MACHINES_STATE_UPDATE, MACHINE_UPDATE, MACHINE_REMOVE
} from "../actions/machineActions";
import {I18nUtils} from "../../../i18n/I18nUtils";
import _ from 'lodash';

const INITIAL_STATE = {
    machines: [],
    machinesPagination: null,
    machinesLoading: false,
    machinesError: null,
    machinesStates: [
        {
            "id": 0,
            "name": I18nUtils.tr('TR_TODOS'),
        },
    ],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MACHINES_STATE_UPDATE:
            return {
                ...state,
                machinesStates: [...INITIAL_STATE.machinesStates, ...action.payload.data],
            };
        case MACHINES_UPDATE:
            return {
                ...state,
                machines: _.mapKeys(action.payload.data, "id"),
                machinesPagination: action.payload.pagination,
                machinesError: action.payload.message,
            };
        case MACHINE_UPDATE:
            const machine = action.payload.data;
            const machines = {...state.machines, [machine.id]: machine};
            return { ...state, machines: machines };
        case MACHINE_REMOVE:
            const machinesToRemove = {...state.machines};
            delete machinesToRemove[action.payload];
            return { ...state, machines: machinesToRemove };
        case MACHINES_ERROR:
            return {
                ...state,
                machinesError: action.payload,
            };
        case MACHINES_LOADING:
            return {
                ...state,
                machinesLoading: action.payload,
            };
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/app/machines/reducers/MachineReducer.js